import { PaymentMethodType } from "../../types/Finance";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { get, post, put } from "../../utils/axios-config";
import { PAYMENT_METHODS } from "../../utils/constants";

export const createPaymentMethod= async (data: PaymentMethodType) => await post<PaymentMethodType, string>(PAYMENT_METHODS, data);
export const updatePaymentMethod = async (data: PaymentMethodType) => await put<PaymentMethodType, string>(PAYMENT_METHODS, data);
export const getPaymentMethods = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    const url = `${PAYMENT_METHODS}?${queryParams.toString()}`;
    return await get<PagedResultsType<PaymentMethodType>>(url)
};